import { Component, OnInit } from '@angular/core';
import { AppVersionService } from './services/app-version/app-version.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {

  constructor(private appVersionService: AppVersionService) {}

  ngOnInit(): void {
    void this.appVersionService.handlePostReloadNavigation();
    this.appVersionService.checkForUpdateOnStartup();
  }

}
